import down_arrow from '#assets/img/down_arrow.svg';
import styled from 'styled-components';

export const InputWrap = styled.div`
  width: 100%;
`;

export const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  span {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translate(50%, -50%);
  }

  & label {
    color: ${({ theme }) => theme.palette.gray25};
    font-weight: 500;
  }
`;

export const InputTagArea = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;

  input[type='text']:focus {
    color: #3f3d43;
    background: var(--color-inputBackground-light);
  }

  /* 캘린더 아이콘을 숨기는 스타일 */
  input[type='date']::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    background: transparent; /* 배경 투명 */
    color: transparent; /* 글자 투명 */
    cursor: pointer;
  }

  /* 기본적으로 placeholder 스타일링 */
  input[type='date']::before {
    content: attr(
      data-placeholder
    ); /* data-placeholder 속성값을 content로 사용 */
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    color: var(--color-border-light);
    display: flex;
    justify-content: flex-start; /* 왼쪽 정렬 */
    align-items: center;
    pointer-events: none; /* 클릭 이벤트 무시 */
    position: absolute; /* 절대 위치로 설정 */
    top: 0;
    left: 0;
    padding-left: 1rem; /* placeholder 텍스트에 좌측 패딩 추가 */
  }

  /* 값이 있는 경우 placeholder 숨김 */
  input[type='date']:valid::before {
    display: none;
  }

  /* input의 텍스트를 투명하게 설정 */
  input[type='date'] {
    color: transparent; /* 텍스트 투명 */
    position: relative; /* 상대 위치 */
  }

  /* 값이 있는 경우 텍스트를 흰색으로 설정 */
  input[type='date']:valid {
    color: #fff; /* 텍스트 색상 #fff로 설정 */
  }

  & > .icon {
    position: absolute;
    right: 2rem;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const InputTag = styled.input<{
  placeholderStyle?: {
    fontSize?: string;
    color?: string;
    fontWeight?: string;
  };
}>`
  width: 100%;
  height: 5.3rem;
  background-color: transparent;
  border: 1px solid var(--color-gray-second);
  border-radius: 0.5rem;
  font-size: 1.6rem;
  padding: 1rem;
  color: var(--color-white);

  ::placeholder {
    color: ${({ placeholderStyle }) =>
      placeholderStyle?.color || 'var(--color-border-light)'};
    font-size: ${({ placeholderStyle }) =>
      placeholderStyle?.fontSize || '1.6rem'};
    font-weight: ${({ placeholderStyle }) =>
      placeholderStyle?.fontWeight || 'normal'};
  }
`;

export const DateInput = styled.input.attrs({ type: 'date' })`
  position: relative; // 캘린더 아이콘을 클릭해야만 달력이 보이기 때문에 이 영역 자체를 제어하기 위해 설정
  width: 100%;
  height: 5.3rem;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.palette.gray400};
  border-radius: 8px;
  font-size: 1.6rem;
  padding: 1rem;
  color: var(--color-white);
  /* background: url(${down_arrow}) no-repeat right 10px center / 15px auto; // 배경에 커스텀 아이콘을 넣어주자! x축은 오른쪽에서부터 10px 떨어지게 하고, y축은 가운데 정렬하고, width 35px에 height auto라는 크기를 부여한다. */

  &.checked {
    &:valid {
      color: black;
    }
  }
`;

export const RequiredMark = styled.div`
  display: inline-block;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.brand300};
`;
